import anime from '../../node_modules/animejs/lib/anime.es.js';

export class Spinner {

    svg_spinner;

    constructor() {
        this.svg_spinner = `
        <div id="dynSpinner" class="spinner dyn-spinner">
            <div class="spinner--svg">
                
            </div>
        </div>`;
        this.stopSpinnerOnWindowLoad();
        this.handleAjaxFilters();
    }

    addDynSpinner(target) {
        target = jQuery(target);
        if( target.length > 0 ) {
            target.html(this.svg_spinner);
        }
    }
    stopDynSpinner() {
        anime({
            targets: '#dynSpinner',
            opacity: 0,
            duration: 500, // Durata dell'animazione
            easing: 'linear', // Tipo di easing
            complete: function() {
                document.querySelector('#dynSpinner').style.display = 'none';
            }
        });
    }

    stopSpinnerOnWindowLoad() {
        window.addEventListener('load', () => {
            setTimeout(() => {
                this.stopSpinner();
            },1000);
        });
    }

    startSpinner() {
        jQuery('#spinner').addClass('spinner--active');
    }

    stopSpinner(spinner = '#spinner') {
        anime({
            targets: spinner,
            opacity: 0,
            duration: 500, // Durata dell'animazione
            easing: 'linear', // Tipo di easing
            complete: function() {
                document.querySelector(spinner).style.display = 'none';
                //this.bannerAnimateds();
                const event = new Event('spinnerStopped');
                window.dispatchEvent(event);
            }
        });
    }

    handleAjaxFilters() {

        jQuery(document).on('yith-wcan-ajax-loading', () => {
            this.startSpinner();
        });

        jQuery(document).on('yith-wcan-ajax-filtered', () => {
            this.stopSpinner('#spinner');
        });
    }

}